import React, { useState, useEffect } from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { mmRecordService } from '../../services/api/mmRecord.service';
import { utils } from "../../services/helpers/utils";

export const MMRecordNoxesInvestigations = (props) => {

    const financiar = props.financiar ? 1 : 0;
    const noxe = props.noxe ?? [];
    const tipFisa = props.tipFisa ?? -1;
    const [dblist, setDBList] = useState([]);
    const [list, setList] = useState([]);
    const [defaults, setDefaults] = useState([]);
    const [dropdown, setDropdown] = useState([]);
    const [noxeInvestigatii, setNoxeInvestigatii] = useState([]);

    const rol = sessionStorage.getItem("rol");

    // Lista de noxe
    useEffect(() => {
        if (props && props.idFisa) {
            mmRecordService.getInvestigations({ recordId: props.idFisa }).then(response => {
                if (response) {
                    setList(response);
                    props.setInvestigatiiNoxe(response);
                    setDBList(response);
                }
            });
        }
    }, [props.refresh]);

    useEffect(() => {
        mmRecordService.getNomInvestigations()
            .then(response => {
                if (response) {
                    setDropdown(response);
                }
            });

        mmRecordService.getNoxesInvestigations()
            .then(response => {
                if (response) {
                    setNoxeInvestigatii(response);
                }
            });
        
    }, []);

    useEffect(() => {
        if (list.length == 0) {
            setDefaults([]);
        }
        else if (list.length > 0 && dropdown.length > 0) {
            let d = [];
            for (var item in list) {
                let el = utils.findObjectById(dropdown, list[item].idInvestigatie)
                if (el) {
                    d.push(el);
                }
            }
            setDefaults(d);
        }
    }, [ list, dropdown]);

    useEffect(() => {
        let newList = [...dblist];
        
        if (noxe.length > 0 && noxeInvestigatii.length > 0) {
            
            for (let i = 0; i < noxe.length; i++) {
                for (let j = 0; j < noxeInvestigatii.length; j++) {
                    if (noxe[i].idNoxa == noxeInvestigatii[j].idNoxa &&
                        (tipFisa == 4 && noxeInvestigatii[j].angajare == 1 ||
                            tipFisa == 5 && noxeInvestigatii[j].angajare == 1 ||
                            tipFisa == 6 && noxeInvestigatii[j].angajare == 1 ||
                            tipFisa == 7 && noxeInvestigatii[j].angajare == 1 ||
                            tipFisa == 8 && noxeInvestigatii[j].luna0 == 1 ||
                            tipFisa == 0 && noxeInvestigatii[j].luna0 == 1 ||
                            tipFisa == 1 && noxeInvestigatii[j].luna3 == 1 ||
                            tipFisa == 2 && noxeInvestigatii[j].luna6 == 1 ||
                            tipFisa == 3 && noxeInvestigatii[j].luna9 == 1)) {


                        const investigatieExistenta = newList.some(item => item.idInvestigatie === noxeInvestigatii[j].investigatie);

                        if (!investigatieExistenta) {
                            newList.push(
                                {
                                    idInvestigatie: noxeInvestigatii[j].investigatie,
                                    dataEfectuarii: null,
                                    suplimentar: 0,
                                    statusFinanciar: financiar,
                                    statusFacturare: 0,
                                    suplimentar: 0
                                })
                        }
                    }
                }
            }
        }

        setList(newList);
        props.setInvestigatiiNoxe(newList);

    }, [props.tipFisa, noxeInvestigatii, noxe])



    useEffect(() => {
        let newList = [...list];
        for (let i = 0; i < newList.length; i++) {
            newList[i].statusFinanciar = financiar;
        }

        setList(newList);
        props.setInvestigatiiNoxe(newList);
    }, [props.financiar]);


    const handleChange = (event, index, field) => {
        const updatedList = [...list];
        var v = event.target.value;
        if (v && v.hasOwnProperty("id")) {
            updatedList[index][field] = v.id;
            setSearchTerm("");
        }
        else {
            updatedList[index][field] = v;
        }
        setList(updatedList);
        props.setInvestigatiiNoxe(updatedList);
    };

  

    return (
        <fieldset>
            <legend className="pt20 pb5">Investigatii obligatorii</legend>
            <table className="tbl tbladd mt5" name="lista_investigatii_noxe" width="100%">
                <thead>
                    <tr>
                        <th width="460">Nume investigatie</th>
                        <th>Data efectuarii</th>
                        <th>Status financiar</th>
                        <th>Status facturare</th>
                    </tr>
                </thead>
                <tbody>
                    {list.map((item, index) => (
                        <tr key={index}>
                            <td name="investigatie">
                                <DropDownList name="id_investigatie"
                                    className="w430 greybg"
                                    data={dropdown}
                                    textField="text"
                                    dataItemKey="id"
                                    defaultItem={defaults[index]}
                                    disabled={true}
                                />
                            </td>
                            <td>
                                <DatePicker name="data_efectuarii"
                                    value={item.dataEfectuarii ? utils.convert2DatePickerDate(item.dataEfectuarii) : null}
                                    max={new Date()}
                                    onChange={(event) => handleChange(event, index, "dataEfectuarii")}
                                    className="text"
                                    disabled={props.finalizare == 1 || rol==2}
                                />
                                
                            </td>
                            <td name="status_financiar"> { item.statusFinanciar } </td>
                            <td name="status_facturare"> { item.statusFacturare} </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </fieldset>
    );
}